import api from "..//axios";
import axiosInstance from "..//axios";

export const getLiveBookingsApi = (branchid: string, filtervalue?: string) => {
    const params: any = { branchid };
    if (filtervalue && filtervalue.trim() !== "") {
        params.filtervalue = filtervalue;
    }
    return axiosInstance.get("/booking/getlivebooking", {
        params,
    });
};

//reassign
export const reassignTripApi = (payload: {
    cabid: string;
    oldcabid: string;
    bookid: number;
    driverid: string;
    reassignby: string;
    emptyKM: number;
    reason: string;
}) => {
    return api.post("/booking/reassigntrip", payload);
};

export const autoCompleteApi = (payload: any) => {
    return api.post("/booking/autocomplete", payload);
};